<template>
  <div>
    <v-container fluid>
      <base-material-card
        icon="mdi-clipboard-text"
        title="รายละเอียดผู้ยื่นย้าย สายบริหาร"
      >
        <v-row>
          <v-col cols="12" md="8">
            <v-alert type="info" dense outlined class="mb-2">
              <strong>ขั้นตอนการดำเนินการ</strong><br />
              1. ให้สถานศึกษาประชุมพิจารณาจากแบบเสนอย้ายของผู้เสนอแต่ละราย<br />
              2. เมื่อพิจารณาเสร็จสิ้น ให้ดำเนินการผ่านระบบ Icon สีเหลือง<br />
              &nbsp;&nbsp;&nbsp;2.1 บันทึกความคิดเห็น<br />
              &nbsp;&nbsp;&nbsp;2.2 แนบไฟล์ผลการพิจารณา (หนังสือนำส่ง วาระการประชุม ผลการพิจารณา) เป็นไฟล์ PDF 1 ไฟล์
            </v-alert>
          </v-col>
          <v-col cols="12" md="4">
            <v-alert type="error" dense outlined>
              <strong>* สายบริหารจะปรากฏเมื่อผู้เสนอย้ายเข้า</strong><br />
              ปิดระบบวันที่ :
              <strong>{{ periods.period_college_stop | moment("D MMMM YYYY") }}</strong>
            </v-alert>
          </v-col>
        </v-row>

        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="ค้นหา ระบุคำ หรือ ส่วนข้อความเกี่ยวข้อง"
          single-line
          hide-details
          dense
          filled
          class="mb-2"
        />

        <v-data-table
          :loading="loading"
          :headers="headers"
          :items="transference_manage_locations"
          :search="search"
        >
          <template v-slot:item="{ item, index }">
            <tr>
              <td class="text-center">
                <v-checkbox v-model="search_college" :value="item.manage_id_ref"></v-checkbox>
              </td>
              <td class="text-center">{{ index + 1 }}</td>
              <td class="text-center">{{ item.manage_id_ref }}</td>
              <td class="text-center">{{ item.title_s }}</td>
              <td class="text-center">{{ item.frist_name }}</td>
              <td class="text-center">{{ item.last_name }}</td>
              <td class="text-center">{{ item.college_code_now }}</td>
              <td class="text-center">{{ item.college_name_now }}</td>
              <td class="text-center">{{ item.time_ss + "/" + item.year_ss }}</td>
              <td class="text-center">{{ item.manage_age_app_time }}</td>
              <td class="text-center">
                <!-- ปุ่มดูแบบเสนอย้าย (เปิด PDF ใน Dialog) -->
                <v-btn
                  text color="info"
                  @click.stop="openPdfmanage_id_refDialog(item)"
                >
                  <v-icon large>mdi-file-pdf-box</v-icon>
                </v-btn>
              </td>
              <td class="text-center">
                <!-- แสดงสถานะความคิดเห็น -->
                <template v-if="item.Mcommittee === 'approp'">
                  <div class="d-flex flex-column align-center" style="gap:4px;">
                    <v-chip
                      color="green" dark style="cursor:pointer;"
                      @click.stop="openPdfDialog(item)"
                    >
                      <v-icon left>mdi-check-circle</v-icon>
                      เห็นควรให้รับย้าย
                      <v-icon right small>mdi-file-pdf-box</v-icon>
                    </v-chip>
                    <v-btn
                      v-if="isWithinPeriod"
                      x-small color="red" text
                      @click.stop="openCancelOpinionDialog(item)"
                    >
                      <v-icon small>mdi-undo</v-icon> ยกเลิก
                    </v-btn>
                  </div>
                </template>
                <template v-else-if="item.Mcommittee === 'inapprop'">
                  <div class="d-flex flex-column align-center" style="gap:4px;">
                    <v-chip
                      color="warning" dark style="cursor:pointer;"
                      @click.stop="openPdfDialog(item)"
                    >
                      <v-icon left>mdi-close-circle</v-icon>
                      ไม่เห็นควรให้รับย้าย
                      <v-icon right small>mdi-file-pdf-box</v-icon>
                    </v-chip>
                    <v-btn
                      v-if="isWithinPeriod"
                      x-small color="red" text
                      @click.stop="openCancelOpinionDialog(item)"
                    >
                      <v-icon small>mdi-undo</v-icon> ยกเลิก
                    </v-btn>
                  </div>
                </template>
                <template v-else>
                  <v-icon
                    v-if="isWithinPeriod"
                    color="yellow darken-2"
                    large
                    @click.stop="select_idPosition(item.manage_id_ref, item.manage_location_id_tfl)"
                  >mdi-credit-card-plus</v-icon>
                  <v-chip v-else color="grey" dark small>ปิดระบบแล้ว</v-chip>
                </template>
              </td>
            </tr>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert">
            ไม่พบผลลัพธ์ "{{ search }}" ที่คุณกำลังค้นหา.
          </v-alert>
        </v-data-table>
      </base-material-card>

      <!-- ─────────────────────────────────────────────
           Dialog: บันทึกความคิดเห็น
      ───────────────────────────────────────────── -->
      <v-layout row justify-center>
        <v-dialog v-model="positiondialog" persistent max-width="80%">
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="yellow"
              icon="mdi-clipboard-text"
              title="ความคิดเห็นคณะกรรมการบริหารสถานศึกษา"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text>
              <v-form ref="updatepositionform" lazy-validation>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-card outlined class="pa-3">
                        <div class="subtitle-2 grey--text">ข้อมูลผู้ยื่นย้าย</div>
                        <div><strong>รหัสอ้างอิง:</strong> {{ transference_manages_id_ref.manage_id_ref }}</div>
                        <div><strong>รหัสบัตรประชาชน:</strong> {{ transference_manages_id_ref.id_card }}</div>
                        <div>
                          <strong>ชื่อ-นามสกุล:</strong>
                          {{ transference_manages_id_ref.title_s }}{{ transference_manages_id_ref.frist_name }}
                          {{ transference_manages_id_ref.last_name }}
                        </div>
                        <div>
                          <strong>สถานศึกษาปัจจุบัน:</strong>
                          {{ transference_manages_id_ref.college_code }} {{ transference_manages_id_ref.college_name }}
                        </div>
                        <div><strong>เลขที่ตำแหน่งปัจจุบัน:</strong> {{ transference_manages_id_ref.id_position }}</div>
                      </v-card>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-card outlined class="pa-3">
                        <div class="subtitle-2 grey--text">ข้อมูลกำหนดการพิจารณาการย้าย</div>
                        <div>
                          <strong>ย้ายครั้งที่:</strong> {{ periods.period_college_times }}
                          <strong>ปี:</strong> {{ periods.period_college_year | moment("YYYY") }}
                        </div>
                        <div>
                          <strong>รอบการย้าย:</strong>
                          {{ periods.period_college_start }} - {{ periods.period_college_stop }}
                        </div>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="12">
                      <v-card elevation="2" class="pa-2">
                        <div class="subtitle-1"><strong>เหตุผลในการย้าย:</strong></div>
                        <div class="body-1">{{ transference_manage_location_s.manage_reason_detail }}</div>
                      </v-card>
                    </v-col>

                    <v-col cols="12" md="12">
                      <v-card elevation="2" class="pa-2">
                        <v-alert class="mx-auto text-center pa-2 ma-2" border="top" colored-border type="info" elevation="2">
                          <h2>ความคิดเห็น</h2>
                          <v-radio-group
                            v-model="transference_manage_location_s.manage_location_status_transfer"
                            row required
                            :rules="[v => !!v || 'กรุณาเลือกความคิดเห็น']"
                            align="center"
                          >
                            <v-radio value="approp">
                              <template v-slot:label>
                                <strong class="primary--text">เห็นควรให้รับย้าย</strong>
                              </template>
                            </v-radio>
                            <v-radio value="inapprop">
                              <template v-slot:label>
                                <strong class="warning--text">ไม่เห็นควรให้รับย้าย</strong>
                              </template>
                            </v-radio>
                          </v-radio-group>
                        </v-alert>
                        <v-col cols="12" md="12">
                          แนบไฟล์ผลการพิจารณา (PDF เท่านั้น)
                          <v-file-input
                            v-model="documentsLinkfiles"
                            accept=".pdf"
                            name="documentsLinkfiles"
                            color="deep-purple accent-4"
                            counter
                            label="ไฟล์ .pdf"
                            placeholder="เลือกแนบไฟล์ PDF"
                            prepend-icon="mdi-paperclip"
                            outlined rounded
                            :show-size="1000"
                            :rules="[v => !!v || 'กรุณาแนบไฟล์ PDF']"
                          >
                            <template v-slot:selection="{ index, text }">
                              <v-chip v-if="index < 2" color="deep-purple accent-4" dark label small>{{ text }}</v-chip>
                              <span v-else-if="index === 2" class="text-overline grey--text text--darken-3 mx-2">
                                +{{ files.length - 2 }} File(s)
                              </span>
                            </template>
                          </v-file-input>
                        </v-col>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="12" class="text-center">
                      <v-alert type="warning" dense outlined>
                        * เมื่อกดบันทึกแล้วไม่สามารถแก้ไขเปลี่ยนแปลงได้ กรุณาตรวจสอบให้ถูกต้อง
                        (สามารถยกเลิกได้ในช่วงที่เปิดระบบเท่านั้น)
                      </v-alert>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large @click.stop="positiondialog = false" rounded>
                <v-icon dark>mdi-close</v-icon> ยกเลิก
              </v-btn>
              <v-btn large color="green" @click.stop="updatepositionSubmit()" rounded :loading="saving">
                <v-icon dark>mdi-content-save</v-icon>&nbsp;บันทึก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- ─────────────────────────────────────────────
           Dialog: ยกเลิกความคิดเห็น
      ───────────────────────────────────────────── -->
      <v-layout row justify-center>
        <v-dialog v-model="cancelOpinionDialog" persistent max-width="60%">
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="red"
              icon="mdi-undo-variant"
              title="ยกเลิกความคิดเห็นของสถานศึกษา"
              class="px-5 py-3 text_google"
            ></base-material-card>
            <v-card-text>
              <v-alert type="warning" prominent>
                <strong>คุณต้องการยกเลิกความคิดเห็นนี้ใช่หรือไม่?</strong>
              </v-alert>
              <v-card outlined class="pa-3 mt-3" v-if="cancelOpinionItem">
                <div><strong>รหัสอ้างอิง:</strong> {{ cancelOpinionItem.manage_id_ref }}</div>
                <div><strong>ชื่อ-นามสกุล:</strong> {{ cancelOpinionItem.title_s }}{{ cancelOpinionItem.frist_name }} {{ cancelOpinionItem.last_name }}</div>
                <div>
                  <strong>ความคิดเห็นเดิม:</strong>
                  <v-chip small :color="cancelOpinionItem.Mcommittee === 'approp' ? 'green' : 'warning'" dark class="ml-2">
                    {{ cancelOpinionItem.Mcommittee === 'approp' ? 'เห็นควรให้รับย้าย' : 'ไม่เห็นควรให้รับย้าย' }}
                  </v-chip>
                </div>
              </v-card>
              <v-textarea
                v-model="cancelReason"
                label="เหตุผลในการยกเลิก *"
                outlined
                rows="3"
                class="mt-4"
                :rules="[v => !!v || 'กรุณาระบุเหตุผล']"
                required
              ></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large @click.stop="cancelOpinionDialog = false" rounded>
                <v-icon dark>mdi-close</v-icon> ปิด
              </v-btn>
              <v-btn large color="red" dark @click.stop="submitCancelOpinion()" rounded :loading="cancelling">
                <v-icon dark>mdi-undo-variant</v-icon>&nbsp;ยืนยันการยกเลิก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <!-- ─────────────────────────────────────────────
           Dialog: ดูไฟล์ PDF (Fullscreen — รองรับ 2 mode)
           pdfMode = 'form'       → แบบเสนอย้าย (openPdfmanage_id_refDialog)
           pdfMode = 'assessment' → ไฟล์ผลการพิจารณา (openPdfDialog)
      ───────────────────────────────────────────── -->
      <v-dialog
        v-model="pdfDialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <!--
          ใช้ position:fixed + top/left/right/bottom=0 แทน flex+100vh
          เพื่อป้องกัน Vuetify card padding ทำให้ layout เสีย
          #pdf-toolbar และ #pdf-infobar มี height คงที่ → iframe ใช้ CSS calc()
        -->
        <v-card tile style="position:fixed; top:0; left:0; right:0; bottom:0; margin:0; border-radius:0; overflow:hidden;">

          <!-- Toolbar -->
          <v-toolbar
            id="pdf-toolbar"
            dense flat dark
            :color="pdfMode === 'form' ? 'teal darken-3' : 'blue-grey darken-4'"
          >
            <v-icon class="mr-2">
              {{ pdfMode === 'form' ? 'mdi-clipboard-account' : 'mdi-file-pdf-box' }} 
            </v-icon>
            <v-toolbar-title class="subtitle-1 font-weight-medium" v-if="pdfItem">
              <template v-if="pdfMode === 'form'">
                แบบเสนอย้าย — {{ pdfItem.title_s }}{{ pdfItem.frist_name }} {{ pdfItem.last_name }}
              </template>
              <template v-else>
                ไฟล์ผลการพิจารณา — {{ pdfItem.title_s }}{{ pdfItem.frist_name }} {{ pdfItem.last_name }}
              </template>
            </v-toolbar-title>
            <v-spacer></v-spacer>

            <!-- เปิดในแท็บใหม่ -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon :href="pdfUrl" target="_blank" v-on="on">
                  <v-icon>mdi-open-in-new</v-icon>
                </v-btn>
              </template>
              <span>เปิดในแท็บใหม่</span>
            </v-tooltip>

            <!-- ดาวน์โหลด -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon :href="pdfUrl" :download="pdfDownloadName" v-on="on">
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </template>
              <span>ดาวน์โหลด</span>
            </v-tooltip>

            <!-- ปิด -->
            <v-btn icon @click="closePdfDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <!-- Info bar (height ≈ 36px) -->
          <v-sheet
            id="pdf-infobar"
            dark class="px-4 py-1"
            :color="pdfMode === 'form' ? 'teal darken-2' : 'blue-grey darken-3'"
            v-if="pdfItem"
          >
            <v-row dense align="center">
              <!-- รหัสอ้างอิง (ทั้ง 2 mode) -->
              <v-col cols="auto">
                <v-icon small class="mr-1">mdi-identifier</v-icon>
                <span class="caption">รหัสอ้างอิง:</span>
                <strong class="ml-1 body-2">{{ pdfItem.manage_id_ref }}</strong>
              </v-col>
              <v-divider vertical class="mx-3 my-1"></v-divider>

              <!-- สถานศึกษาปัจจุบัน (ทั้ง 2 mode) -->
              <v-col cols="auto">
                <v-icon small class="mr-1">mdi-school</v-icon>
                <span class="caption">สถานศึกษาปัจจุบัน:</span>
                <strong class="ml-1 body-2">{{ pdfItem.college_name_now }}</strong>
              </v-col>

              <!-- mode: แบบเสนอย้าย — แสดงชื่อผู้ยื่น -->
              <template v-if="pdfMode === 'form'">
                <v-divider vertical class="mx-3 my-1"></v-divider>
                <v-col cols="auto">
                  <v-icon small class="mr-1">mdi-account</v-icon>
                  <span class="caption">ผู้ยื่นย้าย:</span>
                  <strong class="ml-1 body-2">
                    {{ pdfItem.title_s }}{{ pdfItem.frist_name }} {{ pdfItem.last_name }}
                  </strong>
                </v-col>
                <v-divider vertical class="mx-3 my-1"></v-divider>
                <v-col cols="auto">
                  <v-chip x-small color="teal lighten-1" dark>
                    <v-icon x-small left>mdi-file-document</v-icon>
                    แบบเสนอย้าย
                  </v-chip>
                </v-col>
              </template>

              <!-- mode: ผลการพิจารณา — แสดงความคิดเห็น -->
              <template v-else>
                <v-divider vertical class="mx-3 my-1"></v-divider>
                <v-col cols="auto">
                  <span class="caption">ความคิดเห็น:</span>
                  <v-chip
                    x-small dark class="ml-1 font-weight-bold"
                    :color="pdfItem.Mcommittee === 'approp' ? 'green' : 'orange'"
                  >
                    <v-icon x-small left>
                      {{ pdfItem.Mcommittee === 'approp' ? 'mdi-check' : 'mdi-close' }}
                    </v-icon>
                    {{ pdfItem.Mcommittee === 'approp' ? 'เห็นควรให้รับย้าย' : 'ไม่เห็นควรให้รับย้าย' }}
                  </v-chip>
                </v-col>
              </template>
            </v-row>
          </v-sheet>

          <!--
            PDF Viewer Area
            top = toolbar(48px) + infobar(36px) = 84px
            bottom = footer(44px)
            ใช้ position:absolute แทน flex:1 เพื่อหลีกเลี่ยงปัญหา v-card padding
          -->
          <div style="position:absolute; top:84px; left:0; right:0; bottom:44px; background:#525659; overflow:hidden;">

            <!-- Loading overlay -->
            <v-overlay absolute :value="pdfLoading" color="grey darken-4" opacity="0.85">
              <div class="text-center">
                <v-progress-circular indeterminate size="56" width="4" color="white"></v-progress-circular>
                <div class="mt-3 white--text body-1">กำลังโหลดไฟล์ PDF...</div>
              </div>
            </v-overlay>

            <!-- Error / Fallback state -->
            <div
              v-if="pdfLoadError"
              class="d-flex flex-column align-center justify-center"
              style="height:100%; color:white;"
            >
              <v-icon size="80" color="red lighten-2">mdi-file-pdf-box</v-icon>
              <div class="headline mt-4 mb-2">ไม่สามารถแสดงไฟล์ PDF ได้</div>
              <div class="body-2 grey--text text--lighten-1 mb-6">
                เบราว์เซอร์ของคุณอาจไม่รองรับการแสดง PDF โดยตรง
              </div>
              <div class="d-flex" style="gap:12px;">
                <v-btn color="primary" :href="pdfUrl" target="_blank" rounded>
                  <v-icon left>mdi-open-in-new</v-icon> เปิดในแท็บใหม่
                </v-btn>
                <v-btn color="green" :href="pdfUrl" :download="pdfDownloadName" rounded>
                  <v-icon left>mdi-download</v-icon> ดาวน์โหลด
                </v-btn>
              </div>
            </div>

            <!-- iframe PDF viewer — width/height 100% เต็ม div บน -->
            <iframe
              v-if="pdfDialog && pdfUrl && !pdfLoadError"
              :src="pdfUrl"
              width="100%"
              height="100%"
              style="border:none; display:block; position:absolute; top:0; left:0;"
              type="application/pdf"
              @load="onPdfLoad"
              @error="onPdfError"
            ></iframe>

          </div>

          <!-- Footer (position:absolute ที่ bottom:0, height:44px) -->
          <v-sheet
            dark class="px-4"
            style="position:absolute; bottom:0; left:0; right:0; height:44px; display:flex; align-items:center; justify-content:flex-end;"
            :color="pdfMode === 'form' ? 'teal darken-2' : 'blue-grey darken-3'"
          >
            <v-btn
              v-if="pdfMode === 'assessment' && pdfItem && isWithinPeriod"
              color="red darken-1" small rounded class="mr-2"
              @click="closePdfAndCancel(pdfItem)"
            >
              <v-icon small left>mdi-undo</v-icon> ยกเลิกความคิดเห็น
            </v-btn>
            <v-btn color="white" text rounded @click="closePdfDialog">
              <v-icon left>mdi-close</v-icon> ปิด
            </v-btn>
          </v-sheet>

        </v-card>
      </v-dialog>

      <!-- ─────────────────────────────────────────────
           Dialog: Log การดำเนินการ
      ───────────────────────────────────────────── -->
      <v-layout row justify-center>
        <v-dialog v-model="logDialog" max-width="90%">
          <v-card>
            <base-material-card
              color="blue-grey"
              icon="mdi-history"
              title="Log การดำเนินการ"
              class="px-5 py-3"
            ></base-material-card>
            <v-card-text>
              <v-data-table
                :headers="logHeaders"
                :items="actionLogs"
                dense
                :items-per-page="10"
              >
                <template v-slot:item.log_action="{ item }">
                  <v-chip small :color="getLogColor(item.log_action)" dark>
                    {{ item.log_action }}
                  </v-chip>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="logDialog = false">ปิด</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

    </v-container>

    <v-container fluid>
      <v-snackbar v-model="snackbar.show" top :timeout="snackbar.timeout" :color="snackbar.color">
        <v-icon large>{{ snackbar.icon }}</v-icon>
        <v-card-text>{{ snackbar.text }}</v-card-text>
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false">Close</v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: "1",
      loading: false,
      saving: false,
      cancelling: false,
      ApiKey: "HRvec2021",
      branch_s: [],
      manage_id_ref: [],
      valid: true,
      canceldialog: false,
      positiondialog: false,
      cancelOpinionDialog: false,
      logDialog: false,

      // ── PDF Dialog state ─────────────────────────────────────
      pdfDialog: false,
      pdfItem: null,
      pdfUrl: "",
      pdfLoading: false,
      pdfLoadError: false,
      /**
       * pdfMode: แยกประเภทไฟล์ที่กำลังแสดง
       *   'form'       = แบบเสนอย้าย (เปิดจากปุ่ม mdi-file-pdf-box ในคอลัมน์แบบเสนอย้าย)
       *   'assessment' = ไฟล์ผลการพิจารณา (เปิดจาก chip ความคิดเห็น)
       */
      pdfMode: "form",
      // ────────────────────────────────────────────────────────

      cancelOpinionItem: null,
      cancelReason: "",
      clear_dataDialog: false,
      times_select: "",
      years_select: "",
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },
      time_ss: [1, 2],
      year_ss: [2565, 2566, 2567, 2568, 2569, 2570],
      transference_manage_locations: [],
      edittransference_manage_location: {},
      search: "",
      search_college: "",
      pagination: {},
      singleSelect: false,
      selected: [],
      headers: [
        { text: "เลือก", align: "left", value: "select_item" },
        { text: "#", align: "center", value: "index" },
        { text: "Ref", align: "center", value: "manage_id_ref" },
        { text: "คำนำหน้า", align: "center", value: "title_s" },
        { text: "ชื่อ", align: "center", value: "frist_name" },
        { text: "นามสกุล", align: "center", value: "last_name" },
        { text: "ส.ปัจจุบัน (รหัส)", align: "center", value: "college_code_now" },
        { text: "ส.ปัจจุบัน", align: "center", value: "college_name_now" },
        { text: "ครั้งที่/ปี", align: "center", value: "time_ys" },
        { text: "อายุงาน", align: "center", value: "manage_age_app_time" },
        { text: "แบบเสนอย้าย", align: "center", value: "printmidRef" },
        { text: "ความคิดเห็นกรรมการสถานศึกษา", align: "center", value: "Mcommittee" }
      ],
      logHeaders: [
        { text: "#", value: "log_id", align: "center" },
        { text: "รหัสอ้างอิง", value: "log_manage_id_ref", align: "center" },
        { text: "การดำเนินการ", value: "log_action", align: "center" },
        { text: "ความคิดเห็น", value: "log_committee", align: "center" },
        { text: "เหตุผล/หมายเหตุ", value: "log_remark", align: "left" },
        { text: "ผู้ดำเนินการ", value: "log_user", align: "center" },
        { text: "วันเวลา", value: "log_datetime", align: "center" }
      ],
      actionLogs: [],
      rowsperpage: [25, 50, 100, { text: "All", value: -1 }],
      transference_manage_locationstatus: [],
      transference_manage_locations_id_ref: [],
      conditons_transfer_successs: [],
      updatepositions_condition: {},
      conditons_transfer_success_del: [],
      man_powers: [],
      userstatus: {},
      updatepositions: {},
      man_powerss: [],
      colleges: [],
      data_select: [],
      provinces: [],
      regions: [],
      transference_manages_id_ref: [],
      period_college_times: [],
      periods: [],
      transference_manage_location_s: [],
      addreturn_man_power: {},
      man_power_cancel: {},
      documentsLinkfiles: null
    };
  },

  computed: {
    pages() {
      if (!this.pagination.rowsPerPage || !this.pagination.totalItems) return 0;
      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
    },
    color() {
      return "cyan darken-3";
    },
    period_college_years() {
      return this.periods.period_college_year;
    },

    /** ชื่อไฟล์สำหรับดาวน์โหลด — แยกตาม mode */
    pdfDownloadName() {
      if (!this.pdfItem) return "document.pdf";
      if (this.pdfMode === "form") {
        return `${this.pdfItem.manage_id_ref}_แบบเสนอย้าย.pdf`;
      }
      return `${this.pdfItem.manage_id_ref}_ผลการพิจารณา.pdf`;
    },

    /**
     * ตรวจสอบว่าอยู่ในช่วงเปิดระบบหรือไม่
     * แก้ bug เดิม: flag != 1 || flag != '1' → เป็น true เสมอ
     * แก้เป็น: flag != 1 && flag != '1'
     */
    isWithinPeriod() {
      const flag = this.periods.period_college_enable_file;
      if (!flag) return false;
      if (flag != 1 && flag != "1") return false;
      const now = new Date();
      const stop = this.periods.period_college_stop
        ? new Date(this.periods.period_college_stop)
        : null;
      if (stop && now > stop) return false;
      return true;
    }
  },

  async mounted() {
    let result;
    result = await this.$http.post("collegetype.php", { ApiKey: this.ApiKey });
    this.collegetypes = result.data;

    result = await this.$http.post("college.php", { ApiKey: this.ApiKey });
    this.colleges = result.data;

    result = await this.$http.post("province.php", { ApiKey: this.ApiKey });
    this.provinces = result.data;

    result = await this.$http.post("region.php", { ApiKey: this.ApiKey });
    this.regions = result.data;

    await this.periodQuery();
  },

  methods: {
    async periodQuery() {
      let result_period = await this.$http.post("period_college.php", {
        ApiKey: this.ApiKey,
        period_college_id: "40103"
      });
      this.periods = result_period.data;

      const flag = this.periods.period_college_enable_file;
      if (flag != 1 && flag != "1") {
        Swal.fire({
          icon: "error",
          title: "ยังไม่มีกำหนดการ",
          allowOutsideClick: false,
          allowEscapeKey: false
        }).then(async result => {
          if (result.isConfirmed) {
            this.$router.push("/college");
          }
        });
      } else {
        await this.transference_manage_locationQueryAll();
      }
    },

    async transference_manage_locationQueryAll() {
      this.loading = true;
      let userSession = JSON.parse(sessionStorage.getItem("user")) || 0;
      let result = await this.$http
        .post("transference_manage_location.php", {
          ApiKey: this.ApiKey,
          manage_time_s: this.periods.period_college_times,
          manage_year_s: this.periods.period_college_year,
          manage_location_college_code: userSession.user_name
        })
        .finally(() => (this.loading = false));
      this.transference_manage_locations = result.data;
    },

    async searchTimeYear() {
      this.loading = true;
      let result = await this.$http
        .post("transference_manage_location.php", {
          ApiKey: this.ApiKey,
          time_s: this.times_select,
          year_s: this.years_select
        })
        .finally(() => (this.loading = false));
      this.transference_manage_locations = result.data;
    },

    async select_idPosition(manage_id_ref, manage_location_id_tfl) {
      if (!this.isWithinPeriod) {
        this.showSnackbar("error", "mdi-lock", "ระบบปิดรับการบันทึกแล้ว");
        return;
      }

      let result_con = await this.$http.post("transference_manage.php", {
        ApiKey: this.ApiKey,
        manage_id_ref: manage_id_ref
      });
      this.transference_manages_id_ref = result_con.data;

      let result = await this.$http.post("transference_manage_location.php", {
        ApiKey: this.ApiKey,
        manage_location_id_tfl: manage_location_id_tfl
      });
      this.transference_manage_location_s = result.data;

      this.updatepositions = {};
      this.documentsLinkfiles = null;
      this.positiondialog = true;
    },

    async updatepositionSubmit() {
      if (!this.isWithinPeriod) {
        this.showSnackbar("error", "mdi-lock", "ระบบปิดรับการบันทึกแล้ว");
        return;
      }
      if (!this.$refs.updatepositionform.validate()) return;

      this.saving = true;
      let result = "";
      let uploaded = null;
      let userSession = JSON.parse(sessionStorage.getItem("user"));

      this.updatepositions.ApiKey = this.ApiKey;
      this.updatepositions.manage_location_id_tfl = this.transference_manage_location_s.manage_location_id_tfl;
      this.updatepositions.Mcommittee = this.transference_manage_location_s.manage_location_status_transfer;
      this.updatepositions.manage_location_id_ref = this.transference_manage_location_s.manage_id_ref;
      this.updatepositions.manage_location_college_code = userSession.user_name;

      if (this.documentsLinkfiles) {
        let formData = new FormData();
        let filename =
          this.transference_manage_location_s.manage_id_ref +
          userSession.user_name +
          "collegeAssessment.pdf";
        formData.append("ApiKey", this.ApiKey);
        formData.append("file", this.documentsLinkfiles);
        formData.append("filename", "../HRvecfiles/" + filename);

        result = await this.$http.post("uploadfile.php", formData, {
          headers: { "Content-Type": "multipart/form-data" }
        });
        if (result.data.status == true) {
          this.updatepositions.MdocumentsLinkfile = filename;
          uploaded = true;
        } else {
          uploaded = false;
        }
      } else {
        uploaded = false;
      }

      try {
        let saveResult = await this.$http.post(
          "transference_manage_location.update.php",
          this.updatepositions
        );

        if (saveResult.data.status) {
          await this.writeLog({
            manage_id_ref: this.updatepositions.manage_location_id_ref,
            action: "บันทึกความคิดเห็น",
            committee: this.updatepositions.Mcommittee,
            remark: "บันทึกความคิดเห็น" + (uploaded ? " พร้อมแนบไฟล์" : " (ไม่มีไฟล์แนบ)"),
            user: userSession.user_name
          });

          Swal.fire({
            icon: "success",
            title: "ปรับปรุงข้อมูลเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          this.transference_manage_locationQueryAll();
        } else {
          if (!uploaded) {
            Swal.fire({ icon: "warning", title: "ไฟล์ที่แนบไม่ถูกต้องหรือไม่มีไฟล์แนบ", showConfirmButton: false, timer: 1500 });
          } else {
            Swal.fire({ icon: "warning", title: "บันทึกข้อมูลผิดพลาด", showConfirmButton: false, timer: 1500 });
          }
        }
      } catch (e) {
        Swal.fire({ icon: "error", title: "เกิดข้อผิดพลาด กรุณาลองใหม่", text: e.message });
      } finally {
        this.saving = false;
        this.positiondialog = false;
      }
    },

    // ─────────────────────────────────────────────────────────────
    // PDF Dialog methods
    // ─────────────────────────────────────────────────────────────

    /**
     * เปิด Dialog ดูแบบเสนอย้าย
     * ใช้ path: #/uploads/transference_manage/{manage_id_ref}
     * (ตรงกับ hash-based route ที่ระบบใช้งาน)
     *
     * @param {Object} item - row จาก transference_manage_locations
     */
    openPdfmanage_id_refDialog(item) {
      if (!item || !item.manage_id_ref) {
        this.showSnackbar("warning", "mdi-alert", "ไม่พบรหัสอ้างอิงสำหรับรายการนี้");
        return;
      }
      this.pdfMode = "form";
      this.pdfItem = item;
      // ใช้ hash path ที่ Vue Router ของระบบกำหนดไว้สำหรับ serve ไฟล์
      this.pdfUrl = "/uploads/transference_manage/" + item.manage_file_attachment;
      console.log("Opening PDF URL:", this.pdfUrl); 
      this.pdfLoading = true;
      this.pdfLoadError = false;
      this.pdfDialog = true;
    },

    /**
     * เปิด Dialog ดูไฟล์ผลการพิจารณา (ไฟล์ที่ upload แนบไว้)
     * ใช้ path: /HRvecfiles/{MdocumentsLinkfile}
     *
     * @param {Object} item - row ที่มี MdocumentsLinkfile และ Mcommittee
     */
    openPdfDialog(item) {
      if (!item.MdocumentsLinkfile) {
        this.showSnackbar("warning", "mdi-alert", "ไม่พบไฟล์แนบสำหรับรายการนี้");
        return;
      }
      this.pdfMode = "assessment";
      this.pdfItem = item;
      this.pdfUrl = "/HRvecfiles/" + item.MdocumentsLinkfile;
      this.pdfLoading = true;
      this.pdfLoadError = false;
      this.pdfDialog = true;
    },

    /** iframe โหลดสำเร็จ */
    onPdfLoad() {
      this.pdfLoading = false;
    },

    /** iframe โหลดล้มเหลว → แสดง fallback */
    onPdfError() {
      this.pdfLoading = false;
      this.pdfLoadError = true;
    },

    /** ปิด PDF Dialog และ reset state */
    closePdfDialog() {
      this.pdfDialog = false;
      // รอ transition เสร็จก่อน reset เพื่อไม่ให้ UI กระตุก
      setTimeout(() => {
        this.pdfItem = null;
        this.pdfUrl = "";
        this.pdfLoading = false;
        this.pdfLoadError = false;
        this.pdfMode = "form";
      }, 300);
    },

    /**
     * ปิด PDF Dialog แล้วเปิด cancelOpinion Dialog ต่อทันที
     * ใช้เฉพาะ mode 'assessment' (ปุ่ม footer ใน PDF dialog)
     */
    closePdfAndCancel(item) {
      this.closePdfDialog();
      this.$nextTick(() => {
        this.openCancelOpinionDialog(item);
      });
    },

    // ─────────────────────────────────────────────────────────────

    /** เปิด Dialog ยกเลิกความคิดเห็น */
    openCancelOpinionDialog(item) {
      if (!this.isWithinPeriod) {
        this.showSnackbar("error", "mdi-lock", "ระบบปิดรับการยกเลิกแล้ว");
        return;
      }
      this.cancelOpinionItem = item;
      this.cancelReason = "";
      this.cancelOpinionDialog = true;
    },

    /** ยืนยันการยกเลิกความคิดเห็น */
    async submitCancelOpinion() {
      if (!this.cancelReason || this.cancelReason.trim() === "") {
        this.showSnackbar("warning", "mdi-alert", "กรุณาระบุเหตุผลในการยกเลิก");
        return;
      }
      if (!this.isWithinPeriod) {
        this.showSnackbar("error", "mdi-lock", "ระบบปิดรับการยกเลิกแล้ว");
        return;
      }

      this.cancelling = true;
      let userSession = JSON.parse(sessionStorage.getItem("user"));

      try {
        let result = await this.$http.post("transference_manage_location.update.php", {
          ApiKey: this.ApiKey,
          manage_location_id_ref: this.cancelOpinionItem.manage_id_ref,
          manage_location_college_code: userSession.user_name,    
          Mcommittee: "",
          MdocumentsLinkfile: "",
          manage_location_status_transfer: ""
        });

        if (result.data.status) {
          await this.writeLog({
            manage_id_ref: this.cancelOpinionItem.manage_id_ref,
            action: "ยกเลิกความคิดเห็น",
            committee: this.cancelOpinionItem.Mcommittee,
            remark: this.cancelReason,
            user: userSession.user_name
          });

          Swal.fire({
            icon: "success",
            title: "ยกเลิกความคิดเห็นเรียบร้อยแล้ว",
            showConfirmButton: false,
            timer: 1500
          });
          this.transference_manage_locationQueryAll();
        } else {
          Swal.fire({ icon: "warning", title: "เกิดข้อผิดพลาดในการยกเลิก", showConfirmButton: false, timer: 1500 });
        }
      } catch (e) {
        Swal.fire({ icon: "error", title: "เกิดข้อผิดพลาด", text: e.message });
      } finally {
        this.cancelling = false;
        this.cancelOpinionDialog = false;
        this.cancelOpinionItem = null;
      }
    },

    /** บันทึก Log ไปยัง API */
    async writeLog({ manage_id_ref, action, committee, remark, user }) {
      try {
        await this.$http.post("transference_manage_location_log.php", {
          ApiKey: this.ApiKey,
          log_manage_id_ref: manage_id_ref,
          log_action: action,
          log_committee: committee,
          log_remark: remark,
          log_user: user,
          log_ip: ""
        });
      } catch (e) {
        console.warn("Log write failed:", e);
      }
    },

    /** ดู Log ของรายการ */
    async viewLog(manage_id_ref) {
      try {
        let result = await this.$http.post("transference_manage_location_log.php", {
          ApiKey: this.ApiKey,
          query_manage_id_ref: manage_id_ref
        });
        this.actionLogs = result.data || [];
        this.logDialog = true;
      } catch (e) {
        this.showSnackbar("error", "mdi-alert", "ไม่สามารถโหลด Log ได้");
      }
    },

    getLogColor(action) {
      if (action === "บันทึกความคิดเห็น") return "green";
      if (action === "ยกเลิกความคิดเห็น") return "red";
      return "grey";
    },

    showSnackbar(color, icon, text) {
      this.snackbar.color = color;
      this.snackbar.icon = icon;
      this.snackbar.text = text;
      this.snackbar.show = true;
    },

    getColor() {
      return "green";
    }
  }
};
</script>